import { useContext, useEffect, useRef, useState } from "react";
import KycApplicationContext from "../../Context/KYCApplicationContext/KYCApplicationContext";
import { OptionsEnum } from "../../Enumeration/OptionsEnum";
import { StylePropertiesEnum } from "../../Enumeration/StylePropertiesEnum";
import InitialObjectStructure from "../../FormModel/InitialObjectStructure.json";
import {
  additionalPersonalInfo,
  keyPersonalInfo,
  signatureUpload,
  taxDeclaration,
  VIEW_MODE,
} from "../../Utils/GlobalValues";
import { cloneObject } from "../../Utils/ObjectUtils";
import AlertModal from "../CsplModal/AlertModal";
import AdditionalPersonalInfo from "../Widgets/PersonalDetails/AdditionalPersonalInfo";
import KeyPersonalInfo from "../Widgets/PersonalDetails/KeyPersonalInfo";
import PersonalDetailsJson from "../Widgets/PersonalDetails/PersonalDetailsJson.json";
import SignatureUpload from "../Widgets/PersonalDetails/SignatureUpload";
import TaxDeclaration from "../Widgets/PersonalDetails/TaxDeclaration";
import TabForm from "./TabForm";

function PersonalInfoForm(props) {
  const [initialObjectStructure, setInitialObjectStructure] = useState({});
  const applicationContext = useContext(KycApplicationContext);
  const [isOpenAlertMsgs, setIsOpenAlertMsgs] = useState(false);
  let mode = applicationContext.mode;
  const disableForm = applicationContext.disableForm;
  const [pendingNav, setPendingNav] = useState(null);
  const currentWidget = applicationContext.currentWidget;
  const tabFormRef = useRef(null);
  const [alertMessage, setAlertMessage] = useState("");

  function getComponentByName(name, formData, handleChange, moveToFirstTab) {
    switch (name) {
      case keyPersonalInfo:
        let applicationData = null;
        if (mode === VIEW_MODE) {
          applicationData = props.value;
        } else {
          applicationData = cloneObject(formData);
        }
        return (
          <KeyPersonalInfo
            value={applicationData}
            getApplicationDetails={props.getApplicationDetails}
            setIsLoadingData={props.setIsLoadingData}
          />
        );
      case additionalPersonalInfo:
        return <AdditionalPersonalInfo />;
      case taxDeclaration:
        return (
          <TaxDeclaration
            onSaveToStore={props.onSaveToStore}
            moveToFirstTab={moveToFirstTab}
          />
        );
      case signatureUpload:
        return <SignatureUpload />;
    }
  }

  useEffect(() => {
    //set initial object structure
    setInitialObjectStructure(props.value || InitialObjectStructure);
  }, [props.value]);

  //hanlde next funcion

  const handleNext = (data, currentTabName, suppressSuccessToast) => {
    const isTaxDeclarationTab = currentTabName === taxDeclaration;
    const isValidationRequired = isTaxDeclarationTab && !disableForm;

    if (isValidationRequired) {
      return ResidentialAddressValidation(data)
        .then(() => {
          return props.onNext(data, currentTabName, suppressSuccessToast);
        })
        .catch((error) => {
          return Promise.reject(error);
        });
    }

    return props.onNext(data, currentTabName, suppressSuccessToast);
  };

  // residential Validation function

  function ResidentialAddressValidation(values) {
    const residentStatus =
      values?.personalInfoDTO?.taxDeclarationDTO?.residentOfIndia;

    const residentialCountry =
      values?.personalInfoDTO?.keyPersonalInfoDTO?.residentialCountry
        ?.shortName;

    const isResident = residentStatus === "Resident";
    const isIndia = residentialCountry === "INDIA";

    if (isResident && !isIndia) {
      setAlertMessage(
        "The Residential address should be of India if the residential status is selected as Resident.",
      );
      setIsOpenAlertMsgs(true);
      return Promise.reject("VALIDATION_FAILED");
    }

    if (!isResident && isIndia) {
      setAlertMessage(
        "For NRI and OCI investors, an overseas residential address is required. Kindly provide the correct residential address.",
      );
      setIsOpenAlertMsgs(true);
      return Promise.reject("VALIDATION_FAILED");
    }

    return Promise.resolve(true);
  }

  function clearResidentialValues(values) {
    return {
      ...values,
      personalInfoDTO: {
        ...values.personalInfoDTO,
        keyPersonalInfoDTO: {
          ...values.personalInfoDTO.keyPersonalInfoDTO,
          residentialCountry: null,
          residentialState: null,
          residentialPinCode: null,
          residentialStateName: null,
          residentialCountryName: null,
          residentialCity: null,
          residentialAddressLine3: null,
          residentialAddressLine2: null,
          residentialAddressLine1: null,
          residentialAddressSameAsPermanentAddress: OptionsEnum.No,
        },
      },
    };
  }

  function onClosingAlertModel() {
    setIsOpenAlertMsgs(false);
    props.onNext(
      clearResidentialValues(props.value),
      applicationContext.currentWidget.widgetName,
      true,
    );
    tabFormRef.current?.moveToFirstTab();
  }

  return (
    <>
      {(props.value || InitialObjectStructure) && (
        <TabForm
          ref={tabFormRef}
          id="personalInfoForm"
          currentJson={PersonalDetailsJson.object}
          tabList={PersonalDetailsJson.tabList}
          getComponentByName={getComponentByName}
          initialObjectStructure={initialObjectStructure}
          value={props.value}
          onNext={handleNext}
          onSubmit={props.onSubmit}
          onChange={props.onChange}
          onSaveToStore={props.onSaveToStore}
          moveToFirstTab={props.moveToFirstTab}
        />
      )}
      {/* Alert Modal */}

      <AlertModal
        isModalOpen={isOpenAlertMsgs}
        setIsModalOpen={setIsOpenAlertMsgs}
        modalWidth={StylePropertiesEnum.sm}
        title={"AddressChange.alert"}
        type={StylePropertiesEnum.OKCANCEL}
        data={props.value}
        businessProcess={onClosingAlertModel}
      >
        {alertMessage}
      </AlertModal>
    </>
  );
}
export default PersonalInfoForm;
